import { render, staticRenderFns } from "./ModalEditServiceToConsumer.vue?vue&type=template&id=0097f53f"
import script from "./ModalEditServiceToConsumer.vue?vue&type=script&lang=js"
export * from "./ModalEditServiceToConsumer.vue?vue&type=script&lang=js"
import style0 from "./ModalEditServiceToConsumer.vue?vue&type=style&index=0&id=0097f53f&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0097f53f')) {
      api.createRecord('0097f53f', component.options)
    } else {
      api.reload('0097f53f', component.options)
    }
    module.hot.accept("./ModalEditServiceToConsumer.vue?vue&type=template&id=0097f53f", function () {
      api.rerender('0097f53f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalEditServiceToConsumer.vue"
export default component.exports